import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {AttachmentClassificationForm} from 'src/app/attachment-classifications/AttachmentClassificationForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const CreateAttachmentClassificationPage = () => {
  useSetDocumentTitle('Create Attachment Classification');

  return (
    <ContentWrapper>
      <AttachmentClassificationForm mode="create" />
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.AttachmentClassificationCreate(),
  element: <CreateAttachmentClassificationPage />,
  module: ModuleEnum.AttachmentClassifications,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});

export default CreateAttachmentClassificationPage;
